import { render, staticRenderFns } from "./PesquisaEventoSocial.vue?vue&type=template&id=53680efa&scoped=true"
import script from "./PesquisaEventoSocial.vue?vue&type=script&lang=js"
export * from "./PesquisaEventoSocial.vue?vue&type=script&lang=js"
import style0 from "./PesquisaEventoSocial.vue?vue&type=style&index=0&id=53680efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53680efa",
  null
  
)

export default component.exports